/* prettier-ignore */
export const billingRuleActions = {
  CLICK_BILLING_RULE_CHANGE_PRIORITY: "CLICK_BILLING_RULE_CHANGE_PRIORITY",
  CLICK_BILLING_RULE_CREATE: "CLICK_BILLING_RULE_CREATE",
  CLICK_BILLING_RULE_CREATE_FORM_OPEN: "CLICK_BILLING_RULE_CREATE_FORM_OPEN",
  CLICK_BILLING_RULE_DELETE: "CLICK_BILLING_RULE_DELETE",
  CLICK_BILLING_RULE_UPDATE: "CLICK_BILLING_RULE_UPDATE",
  CLICK_BILLING_RULE_UPDATE_FORM_OPEN: "CLICK_BILLING_RULE_UPDATE_FORM_OPEN",
} as const;
